<div class="modal-body content width-900 height-900">
  <div class="layout-auto-1-auto">
    <div class="modal-header">
      Seiten auswählen
    </div>
    <div class="app-pagepicker content grid-1-auto" cdkDropListGroup>
      <div class="content grid cols-2">
        <!--Left Side-->
        <div class="content md3-card layout-auto-1 pagecontainer">
          <h6>Ausgesuchte Seiten</h6>
          <div cdkDropList [cdkDropListData]="selectedPagesLeftSide"
               (cdkDropListDropped)="drop($event)"
               [cdkDropListEnterPredicate]="isPicDropAvailable" class="stack-center content">
            <ng-container *ngFor="let item of selectedPagesLeftSide">
              <div cdkDrag [cdkDragData]="item" class="pagepicker-page">
                <img *ngIf="item.dokPages > 1 && item?.selectedPage"
                     src="{{excRest.computeUrl('ImageThumbnailBig',{dokID: item.dokID, page: item.selectedPage-1})}}"
                />
              </div>
            </ng-container>
          </div>


        </div>
        <!--Right Side-->
        <div  class="content md3-card app-space-left layout-auto-1 pagecontainer">
          <h6>Alle Seiten</h6>
          <div cdkDropList [cdkDropListData]="allPagesRightSide"
               (cdkDropListDropped)="drop($event)"
               [cdkDropListEnterPredicate]="isPicDropAvailable" class="content stack-center">
            <ng-container *ngFor="let item of allPagesRightSide">
              <div cdkDrag [cdkDragData]="item" class="pagepicker-page">
                <img *ngIf="item.dokPages > 1 && item?.selectedPage"
                     src="{{excRest.computeUrl('ImageThumbnailBig',{dokID: item.dokID, page: item.selectedPage-1})}}"
                />
              </div>
            </ng-container>
          </div>

        </div>
      </div>
    </div>
    <div class="spawn-modal-actions typo-small">
      <button (click)="selectAllPages()"
              [disabled]="allPagesRightSide.length === 0"
              class="md-btn">
        Alle auswählen
      </button>
      <button (click)="deselectAllPages()"
              [disabled]="selectedPagesLeftSide.length === 0"
              class="md-btn">
        Auswahl aufheben
      </button>
      <button (click)="cancel()"
              class="md-btn">
        Abbrechen
      </button>
      <button (click)="save()"
              [disabled]="selectedPagesLeftSide.length === 0"
              class="md-btn">
        Speichern
      </button>
    </div>
  </div>
</div>
